export default "__VITE_ASSET__CyA0A_7G__"